import { Validators } from '@angular/forms';

export function signedIntegerValidators() {
   return [Validators.min(-2147483648), Validators.max(2147483647), Validators.pattern(/^\d+$/)];
}
export function nullableSignedIntegerValidators() {
   return [Validators.min(-2147483648), Validators.max(2147483647), Validators.pattern(/^\s*\d+\s*$/)];
}
export function unsignedNonZeroIntegerValidators() {
   return [Validators.min(1), Validators.max(999), Validators.pattern(/^\d+$/)];
}
